import * as React from 'react'
import { useParams } from 'react-router-dom'
import { ErrorBoundary } from 'react-error-boundary'

import './irtis-3.css'

import Header from './components/Header'
import { ServerTimeProvider } from './contexts/serverTime.context'
import { SWRConfig } from 'swr'
import { localStorageProvider } from './utils/cache.utils'
import Views from './components/Views'
import StateScreen, { StateType } from './components/StateScreen'

const Irtis3Page: React.FC = () => {
  const urlPathParams = useParams()
  React.useEffect(() => {
    document.title = 'Irtis 3'
  }, [])

  return (
    <SWRConfig
      value={{
        provider: (cache) => localStorageProvider(cache, urlPathParams),
      }}
    >
      <ServerTimeProvider>
        <div className="bg-blue-200 h-full flex flex-col">
          <Header />
          <ErrorBoundary fallback={<StateScreen type={StateType.ERROR} />}>
            <Views />
          </ErrorBoundary>
        </div>
      </ServerTimeProvider>
    </SWRConfig>
  )
}

export default Irtis3Page
